<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<path d="M21,5.62c0.55,0,1,0.45,1,1v10.77c0,0.55-0.45,1-1,1H3c-0.55,0-1-0.45-1-1V6.62c0-0.55,0.45-1,1-1H21z M16,7.46
	c-0.97,0-1.75,0.78-1.75,1.75s0.78,1.75,1.75,1.75c0.97,0,1.75-0.78,1.75-1.75S16.97,7.46,16,7.46z M10,8.5H4V10h6V8.5z
	 M18.25,11.21h-0.58c-0.43,0.48-1.04,0.75-1.67,0.75c-0.64,0-1.25-0.27-1.67-0.75h-0.58v0.55c-0.22,0.12-0.47,0.26-0.75,0.45
	c-0.5,2-1,2.9-1,3.75c0.68,0.27,1.41,0.47,2.15,0.59l1.17-0.93c0.7,0.05,2.12-0.1,3.1-0.36l0.29,1.11c0.44-0.11,0.87-0.24,1.29-0.41
	c0-0.87-0.5-1.75-1-3.75c-0.29-0.19-0.53-0.33-0.75-0.45V11.21z M10,11.25H4v1.5h6V11.25z M10,14H6v1.5h4V14z"/>
</svg>

</template>